var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"step",class:{
      final: this.final,
      done: this.getSolutionState.isDone(_vm.order),
      current: this.getSolutionState.isCurrent(_vm.step_id),
      error: this.getSolutionState.isError(_vm.step_id),
    }},[_vm._v(" "+_vm._s(_vm.step_name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }